<template lang="pug">
.fioBlock(:class="{'fio-block-old-profiles': oldProfiles}")
  p.title-xl.capitalize.mt-3(v-if="full", data-qa="step1-receiver-title") {{ $t('receiver_title') }}
  p.fioBlock-subtitle(v-if="oldProfiles") {{ $t('profiles_error_data') }}
  div.description-xl-dark.fioBlock-profile-info(v-if="oldProfiles")
    p {{ profileInfo?.NAME }},
    .fioBlock-profile-info-footer
      span {{ $formatPhone(profileInfo?.PHONE) }},
      span {{ profileInfo?.EMAIL }}
  .name-inputs.w-full.grid.grid-cols-6.gap-4.mt-4(class="max-lg1024:flex-col",:class="{ 'flex-col': full, 'max-w-[100%]': full }")

    .latinOnly_block.flex.justify-start.basket-row.col-span-6(v-if="errors.latinOnlyError")
      .icon.mr-1
        ExclamationAlertIcon(color="#ff585d", topPosition="4")
      p.text-accentColor {{ $t('latin_only_russian_error') }}

    //- ФИО в одно поле
    .name-input.flex.flex-col.col-span-6(v-if="needFullFioInField")
      label.flex(for="fullFioInField")
        | {{ $t('reciever_fio') }}
        span.required *
      input.border.border-gray-2.input-wrap.mt-0#fullFioInField(
        ref="fio",
        type="text",
        data-qa="step1-full-fio-input",
        :placeholder="$t('receiver_fio_placeholder')",
        v-model="fullFioInField",
        @focusout="tryCheckDuplicate",
        :class="[{'has-error': getFullFioInField?.length}]"
      )
      .mb-2.text-sm.text-accentColor(v-if="focused.fullFioInField && getFullFioInField?.length", data-qa="step1-error-fullfio")
        p {{ getFullFioInField }}

    //- Фамилия
    .name-input.flex.flex-col.col-span-6(
      v-if="!needFullFioInField",
      :class="{'lg1024:col-span-3' : !['RU','UA'].includes(country) && !full, 'lg1024:col-span-2': ['RU','UA'].includes(country) && !full}"
    )
      label.flex(for="surname-field")
        | {{ $t('reciever_family') }}
        span.required(v-if="!oldProfiles") *
      input.border.border-gray-2.input-wrap.mt-0#surname-field(
        type="text",
        data-qa="step1-surname-input",
        v-model="surname",
        @keydown.space.prevent,
        @focusout="tryCheckDuplicate",
        :class="[{'has-error': surnameError?.length}, {warning: oldProfiles}]"
      )
      .mb-2.text-sm.text-accentColor(v-if="focused.SURNAME && surnameError?.length", data-qa="step1-error-surname")
        p {{ surnameError }}

    //- Имя
    .name-input.flex.flex-col.col-span-6(
      v-if="!needFullFioInField",
      :class="{'lg1024:col-span-3' : !['RU','UA'].includes(country) && !full, 'lg1024:col-span-2': ['RU','UA'].includes(country) && !full}"
    )
      label.flex(for="person-name-field")
        | {{ $t('reciever_name') }}
        span.required(v-if="!oldProfiles") *
        .popup.ml-2(v-if="country === 'DE'", ref="popup", @click="isPopupShow = !isPopupShow")
          QuestionIcon
          dialog(
            :class="{'name-dialog': isMobileTooltip}",
            :open="isPopupShow",
            v-click-outside="closePopup"
          ) {{ $t('tooltip_name_de') }}
      input.border.border-gray-2.input-wrap.mt-0#person-name-field(
        type="text",
        data-qa="step1-name-input",
        v-model="personName",
        @keydown.space.prevent,
        @focusout="tryCheckDuplicate",
        :class="[{ 'has-error': nameError?.length }, { warning: oldProfiles }]")

      .mb-2.text-sm.text-accentColor(v-if="focused.NAME && nameError?.length", data-qa="step1-error-name")
        p {{ nameError }}

    //- Отчество
    .name-input.flex.flex-col.col-span-6(v-if="!needFullFioInField", v-show="['RU','UA'].includes(country)", :class="{'lg1024:col-span-3' : !['RU','UA'].includes(country) && !full, 'lg1024:col-span-2': ['RU','UA'].includes(country) && !full}")
      label.text-lighter(for="patronymic-field")
        | {{ $t('profile-second-name') }}
      input.border.border-gray-2.input-wrap.mt-0#patronymic-field(type="text", v-model="patronymic", data-qa="step1-patronymic-input")

    //- Телефон
    .name-input.flex.flex-col.col-span-6(:class="{'lg1024:col-span-3': !full}")
      label.phone-label(for="phone-field")
        | {{ $t('reciever_phone') }}
        span.required(v-if="!oldProfiles") *
        .popup.ml-2(v-if="country === 'DE'", ref="popup", @click="phonePopup = !phonePopup")
          QuestionIcon
          dialog(:open="phonePopup", v-click-outside="closePhonePopup")
            | {{ $t('checkout_de_phone_tooltip') }}
      .phone-select-wrapper(
        data-qa="step1-phone-container",
        @focusout="onPhoneFocusOut",
        :class="{ 'phone-select-disabled': duplicateCheckLoading }"
      )
        PhoneSelect(
          :key="`phone-${selectedProfileId}-${phoneSelectKey}`"
          id="phone-field",
          ref="phoneSelect",
          v-model="phone",
          :country="country",
          :countries="filteredCountries",
          @setErrorMaskLength="setErrorMaskLength",
          @setCustomError="setCustomError",
          :warning="oldProfiles",
          data-qa="step1-phone-select-input"
        )
      .mb-2.text-sm.text-accentColor(v-if=`
        errors.fields.userField.PHONE &&
        errors.fields.userField.PHONE.length
      `, data-qa="step1-error-phone")
        p {{ errors.fields.userField.PHONE }}
      .mb-2.text-sm.text-accentColor(
        v-if='errors.fields.userField.PhoneCustom'
      )
        p {{ errors.fields.userField.PhoneCustom }}
      .notification_spain(v-if="country === 'ES'" ) {{ $t('phone_notification_spain') }}

    //- Почта
    .name-input.flex.flex-col.col-span-6(:class="{'lg1024:col-span-3': !full}")
      label.flex(for="email-field" :class="[{'lowercase-label': isProfiles}]")
        | {{ this.$t('reciever_email') }}
        span.required(v-if="!oldProfiles") *
      input.border.border-gray-2.input-wrap.mt-0(type="email",
        id="email-field",
        data-qa="step1-email-input",
        v-model="email",
        :disabled="duplicateCheckLoading",
        @focusout="onEmailFocusOut",
        :class=`[{
          'has-error':
            errors.fields.userField.EMAIL &&
            errors.fields.userField.EMAIL.length,
        }, {warning: oldProfiles}]`)
      .mb-2.text-sm.text-accentColor(v-if=`
        focused.EMAIL &&
        errors.fields.userField.EMAIL &&
        errors.fields.userField.EMAIL.length
        `, data-qa="step1-error-email")
        p {{ errors.fields.userField.EMAIL }}
    //- Комментарий к адресу
    .flex.flex-col.justify-end.mt-3.w-full.col-span-6(v-if="isHiddenCommentBlock")
      .latinOnly_block.flex.justify-start.basket-row.col-span-6(v-if="latinOnlyCommentError")
        .icon.mr-1
          ExclamationAlertIcon(color="#ff585d", topPosition="2", class="mr-1")
        p.text-accentColor {{ $t('latin_only_russian_error') }}

      .flex.flex-col(v-if="country === 'CY'")
        Notification.purpleHolder.py-3.px-5.gap-4.items-center.mb-5(
          :text="$t('cyprus_notification')",
          text-color="#39444C",
          :icon-size="24"
        )
        label.text-lighter(for="profileAddressComment") {{ 'Комментарий к заказу' }}
        input#profileAddressComment.border.border-gray-2.p-3.mt-1.input-wrap(
          type="text",
          data-qa="step1-address-comment-input",
          v-model="profileComment",
          placeholder="Пункт ACS, Сompany name, c/o, PO box number",
          ref="profileCommentInput",
          autocomplete="off"
        )
      .flex.flex-col(v-else)
        label.text-lighter(for="profileAddressComment") {{ $t('address_comment') }}
        input#profileAddressComment.border.border-gray-2.p-3.mt-1.input-wrap(
          type="text",
          data-qa="step1-address-comment-input",
          v-model="profileComment",
          ref="profileCommentInput",
          autocomplete="off"
        )
</template>
<script>
import { mapState } from 'vuex'
import PhoneSelect from '@temi4.1302/phone-select/dist/vue3/index.es.js'
// при локальной разработке PhoneSelect нужно иметь на одном уровне проект phone-select, подключить алиасы в вит конфиг и вставляем этот код:
// import PhoneSelect from '@temi4.1302/phone-select'
// и комментируем ниже css
import '@temi4.1302/phone-select/dist/style.css'

import QuestionIcon from '@/components/svg/QuestionIcon.vue'
import ExclamationAlertIcon from '@/components/svg/ExclamationAlertIcon.vue'
import Notification from '@/components/Notification.vue'

export default {
  components: {
    Notification,
    PhoneSelect,
    QuestionIcon,
    ExclamationAlertIcon,
  },
  props: {
    full: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Object,
      default: function () {
        return {
          FIO: '',
          PHONE: '',
          EMAIL: '',
        }
      },
    },
    isMobileTooltip: {
      type: Boolean,
      default: false,
    },
    oldProfiles: {
      type: Boolean,
      default: false,
    },
    isProfiles: {
      type: Boolean,
      default: false,
    },
    profileInfo: {
      type: Object,
      default: () => {},
    },
    profileAddressComment: {
      type: String,
      default: '',
    },
    shouldCheckDuplicates: {
      type: Boolean,
      default: false,
    },
    duplicateCheckLoading: {
      type: Boolean,
      default: false,
    },
    mustEditField: {
      type: Boolean,
      default: false,
    },
  },
  name: 'FioBlock',
  data() {
    return {
      fieldsConfig: {},
      isPopupShow: false,
      phonePopup: false,
      popUpClicked: false,
      phonePopupClicked: false,
      errors: {
        fields: {
          userField: {
            FIO: false,
            PHONE: false,
            PhoneCustom: false,
            EMAIL: false,
            personName: false,
            surname: false,
            fullFioInField: false,
          },
        },
        latinOnlyError: false,
      },
      focused: {
        EMAIL: false,
        NAME: false,
        SURNAME: false,
        fullFioInField: false,
      },
      latinOnlyCommentError: false,
      phoneSelectKey: 0,
    }
  },
  watch: {
    isPopupShow(value) {
      if (value) {
        this.popUpClicked = true
        setTimeout(() => {
          this.popUpClicked = false
        }, 1000)
      }
    },
    phonePopup(value) {
      if (value) {
        this.phonePopupClicked = true
        setTimeout(() => {
          this.phonePopupClicked = false
        }, 1000)
      }
    },

    fioFieldFocusState(val) {
      if (val) {
        this.$refs.fio?.focus()
      }
    },
    mustEditField() {
      this.validateAndEmitStatus()
    },
    fields: {
      handler() {
        this.$nextTick(() => {
          this.validateAndEmitStatus()
        })
      },
      deep: true,
    },
  },
  computed: {
    ...mapState(['filteredCountries', 'fioFieldFocusState']),

    userInfo: {
      get() {
        return this.fields || {} // всегда актуальные данные от родителя
      },
      set(val) {
        this.$emit('fields', val)
        this.$nextTick(() => {
          this.validateAndEmitStatus()
        })
      },
    },
    fullFioInField: {
      get() {
        return this.needFullFioInField ? this.userInfo?.FIO : false
      },
      // корректно вызываем computed-setter userInfo?. Прямое изменение this.userInfo?.FIO = … мутирует вложенный объект и не будет вызывать сеттер userInfo
      set(value) {
        if (this.needFullFioInField) {
          this.setFocusActive('fullFioInField')

          const sanitizedValue = this.removeSymbols(value)
          this.validateFullFio(sanitizedValue)
          this.userInfo = {
            ...this.userInfo,
            FIO: sanitizedValue,
          }
        }
      },
    },
    surname: {
      get() {
        const [surname = ''] = this.userInfo.FIO.split(' ') ?? ''
        return surname
      },
      set(value) {
        this.setFocusActive('surname-field')
        const sanitizedValue = this.removeSymbols(value)
        this.validateFormField('surname', sanitizedValue, true)
        const parts = this.userInfo.FIO.split(' ')
        parts[0] = sanitizedValue

        this.userInfo = {
          ...this.userInfo,
          FIO: parts.join(' '),
        }
      },
    },
    personName: {
      get() {
        const [, personName = ''] = this.userInfo.FIO.split(' ') ?? ''
        return personName
      },
      set(value) {
        this.setFocusActive('person-name-field')
        const sanitizedValue = this.removeSymbols(value)
        this.validateFormField('personName', sanitizedValue, true)
        const parts = this.userInfo.FIO.split(' ')
        parts[1] = sanitizedValue

        this.userInfo = {
          ...this.userInfo,
          FIO: parts.join(' '),
        }
      },
    },
    patronymic: {
      get() {
        const [, , patr = ''] = this.userInfo.FIO.split(' ') ?? ''
        return patr
      },
      set(value) {
        const sanitizedValue = this.removeSymbols(value)
        const parts = this.userInfo.FIO.split(' ')
        parts[2] = sanitizedValue
        this.userInfo = {
          ...this.userInfo,
          FIO: parts.join(' '),
        }
      },
    },
    phone: {
      get() {
        return this.userInfo?.PHONE
      },
      set(value) {
        this.userInfo = {
          ...this.userInfo,
          PHONE: value,
        }
      },
    },
    email: {
      get() {
        // Безопасно возвращаем email или пустую строку
        return this.userInfo?.EMAIL || ''
      },
      set(value) {
        this.validateEmail(value)

        this.userInfo = {
          ...this.userInfo,
          EMAIL: value,
        }
      },
    },

    country() {
      const country = this.$store.state.country.code
      return country
    },
    needFullFioInField() {
      return (
        this.$checkoutOptions?.COUNTRIES_FIO_ONE_FIELD?.includes(
          this.country
        ) ?? false
      )
    },
    nameError() {
      return this.errors.fields.userField.personName
    },
    surnameError() {
      return this.errors.fields.userField.surname
    },
    getFullFioInField() {
      return this.errors.fields.userField.fullFioInField
    },
    selectedProfileId() {
      return this.$store.state.SELECTED_PROFILE?.PROFILE_ID
    },
    isHiddenCommentBlock() {
      return this.$store.getters.isHiddenCommentBlock
    },

    profileComment: {
      get() {
        return this.profileAddressComment || ''
      },
      set(value) {
        const sanitized = this.sanitizeComment(value)
        this.latinOnlyCommentError = sanitized.length !== value.length
        this.$emit('update:profileAddressComment', sanitized)

        this.$nextTick(() => {
          if (
            this.$refs.profileCommentInput &&
            this.$refs.profileCommentInput.value !== sanitized
          ) {
            this.$refs.profileCommentInput.value = sanitized
          }
        })
      },
    },
  },
  beforeMount() {
    this.getFieldsConfig()
    if (this.needFullFioInField) this.fullFioInField = this.fields.FIO
  },

  methods: {
    getFieldsConfig() {
      this.fieldsConfig = this.$store.state.checkoutFields
      const USER_INFO_FIELDS = [
        {
          group: 'USER_INFO_FIELDS',
          label: this.$t('reciever_fio'),
          name: 'FIO',
          required: true,
          type: 'text',
        },
        {
          group: 'USER_INFO_FIELDS',
          label: this.$t('reciever_phone'),
          name: 'PHONE',
          required: true,
          type: 'tel',
        },
        {
          group: 'USER_INFO_FIELDS',
          label: this.$t('reciever_email'),
          name: 'EMAIL',
          required: true,
          type: 'email',
        },
      ]
      this.fieldsConfig.USER_INFO_FIELDS = USER_INFO_FIELDS
      if (!this.fieldsConfig) {
        throw new Error(this.$t('fields_config_error'))
      }
    },

    validateFormField(field, value, needCheckLength) {
      // if (this.$latinOnly && value.length > 0)
      //   checkLatinOnly(
      //     value,
      //     [this.dename, this.defamily, this.fullFioInField],
      //     this.setErrorState,
      //     this.$latinRegex
      //   )

      if (value.length < 2 && needCheckLength) {
        this.errors.fields.userField[field] = this.$t('fill_that_field')
      } else this.errors.fields.userField[field] = false
    },

    isFullFioValid(value) {
      const words = (value || '').trim().split(/\s+/).filter(Boolean)
      return words.length >= 2 && words.every((word) => word.length >= 2)
    },

    validateFullFio(value) {
      this.errors.fields.userField.fullFioInField = this.isFullFioValid(value)
        ? false
        : this.$t('enter_first_and_last_name')
    },

    validateEmail(value) {
      this.setFocusActive('email-field')
      const emailValue = value || ''
      const re =
        // eslint-disable-next-line no-useless-escape
        /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
      if (!re.test(emailValue)) {
        this.errors.fields.userField.EMAIL = this.$t('wrong_email')
      } else {
        this.errors.fields.userField.EMAIL = false
      }
    },
    validateAndEmitStatus() {
      const noErrors = Object.values(this.errors.fields.userField).every(
        (err) => err === false
      )
      const requiredFieldsFilled =
        (this.needFullFioInField
          ? this.isFullFioValid(this.fullFioInField)
          : this.surname.trim().length >= 2 &&
            this.personName.trim().length >= 2) &&
        this.userInfo.PHONE.length > 5 &&
        this.userInfo.EMAIL.includes('@')

      // Блокируем переход к следующему шагу пока mustEditField === true
      this.$emit(
        'isValid',
        noErrors && requiredFieldsFilled && !this.mustEditField
      )
    },

    areAllRequiredFieldsValid() {
      const noErrors = Object.values(this.errors.fields.userField).every(
        (err) => err === false
      )
      const fioFilled = this.needFullFioInField
        ? this.isFullFioValid(this.fullFioInField)
        : this.surname?.trim().length >= 2 &&
          this.personName?.trim().length >= 2
      const phoneFilled = this.userInfo?.PHONE?.length > 5
      const emailFilled = this.userInfo?.EMAIL?.includes('@')

      return noErrors && fioFilled && phoneFilled && emailFilled
    },
    tryCheckDuplicate() {
      if (!this.shouldCheckDuplicates) return
      if (!this.areAllRequiredFieldsValid()) return

      this.$emit('checkDuplicate')
    },
    onEmailFocusOut() {
      this.tryCheckDuplicate()
    },
    onPhoneFocusOut(event) {
      // Проверяем, что фокус ушёл за пределы обёртки телефона
      const wrapper = event.currentTarget
      const relatedTarget = event.relatedTarget
      if (relatedTarget && wrapper.contains(relatedTarget)) {
        return
      }

      this.tryCheckDuplicate()
    },
    clearField(field) {
      if (field === 'email') {
        this.userInfo = { ...this.userInfo, EMAIL: '' }
      } else if (field === 'phone') {
        this.userInfo = { ...this.userInfo, PHONE: '' }
        this.phoneSelectKey++
      } else if (field === 'email_phone') {
        this.userInfo = { ...this.userInfo, EMAIL: '', PHONE: '' }
        this.phoneSelectKey++
      }
    },

    closePopup() {
      if (!this.popUpClicked) this.isPopupShow = false
    },
    closePhonePopup() {
      if (!this.phonePopupClicked) this.phonePopup = false
    },
    removeSymbols(value) {
      // no cyr
      // if (value && value !== null && this.$noCyrSymbols && value.length > 0) {
      //   value = value
      //     .split('')
      //     .filter((char) => !this.$cyrLetters.includes(char))
      //     .join('')
      // }
      //latin only
      if (value !== null && this.$latinOnly && value.length > 0) {
        this.checkLatinOnly(value)
        value = value.replace(this.$latinRegex, '')
      }

      return value
    },
    checkLatinOnly(value) {
      if (!this.isLatin(value)) this.errors.latinOnlyError = true
      else if (
        this.personName.length > 1 ||
        this.surname.length > 1 ||
        this.fullFioInField.length > 1
      )
        this.errors.latinOnlyError = false
    },
    isLatin(value) {
      return !this.$latinRegex.test(value)
    },
    setFocusActive(id) {
      const active = document.activeElement.getAttribute('id') === id
      switch (id) {
        case 'email-field':
          this.focused.EMAIL = active
          break
        case 'person-name-field':
          this.focused.NAME = active
          break
        case 'surname-field':
          this.focused.SURNAME = active
          break
        case 'fullFioInField':
          this.focused.fullFioInField = active
          break
      }
    },
    getFieldPropertyValue(group, field, property) {
      if (group && field && property && this.fieldsConfig[group]) {
        let foundField = this.fieldsConfig[group].find(
          (item) => item.name == field
        )
        if (foundField) {
          return foundField[property]
        }
      } else {
        return false
      }
    },
    setErrorMaskLength(error) {
      if (error) {
        this.errors.fields.userField.PHONE = this.$t('wrong_phone')
        this.phone = ''
      } else {
        this.errors.fields.userField.PHONE = false
      }
    },
    setCustomError(data) {
      if (!data) {
        this.errors.fields.userField.PhoneCustom = false
        return
      }

      const { error, country } = data
      if (error) {
        this.phone = ''
        switch (country) {
          case 'LV':
            this.errors.fields.userField.PhoneCustom = this.$t(
              'number_must_start_from_2'
            )
            break
          case 'RO':
            this.errors.fields.userField.PhoneCustom = this.$t(
              'number_must_start_from_7'
            )
            break
          // для других стран
          default:
            this.errors.fields.userField.PhoneCustom = this.$t('wrong_phone')
        }
      } else {
        this.errors.fields.userField.PhoneCustom = false
      }
    },
    sanitizeComment(value) {
      if (typeof value === 'string' && value.length > 0) {
        return value.replace(this.$latinRegex, '')
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.popup {
  position: relative;

  svg {
    width: 20px;
    height: 20px;
    color: #dcdcdc;
    margin-left: 2px;
  }

  dialog {
    position: absolute;
    top: 50%;
    min-width: 280px;
    left: calc(100% + 16px);
    transform: translateY(-50%);
    color: white;
    background-color: #333f48;
    padding: 12px;
    outline: none;
    z-index: 2;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.25;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      width: 16px;
      height: 16px;
      background-color: inherit;
      transform: translate(-50%, -50%) rotate(45deg);
    }
  }
}

@media (max-width: 767px) {
  .popup {
    dialog {
      top: auto;
      bottom: 30px;
      left: -68px;
      transform: translateY(0);

      &::before {
        left: 80px;
        top: 100%;
      }
    }
  }
}
.phone-label {
  display: flex;
  align-items: center;
}
label {
  margin-bottom: 4px;
  font-size: 14px;
  color: #75828b;
}
.fioBlock-subtitle {
  color: #646d74;
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 20px;
}
.fioBlock-profile-info {
  padding: 16px;
  border-radius: 8px;
  background: rgba(47, 128, 237, 0.08);
  display: flex;
  flex-direction: column;

  &-footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
  }
}
.warning {
  border: 2px solid #f7ceb2;
  background: #fef7f2 !important;
}
.fio-block-old-profiles {
  label {
    color: #858c91;
    font-feature-settings:
      'clig' off,
      'liga' off;
    font-family: Rubik;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
  }
}
.lowercase-label {
  text-transform: lowercase;
}

.notification_spain {
  margin-top: 6px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -1.4%;
  color: rgba(142, 154, 164, 1);
}

.phone-select-disabled {
  pointer-events: none;
  opacity: 0.6;
}
</style>
